import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=44d30538"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports